import { render, staticRenderFns } from "./PercentageDropdown.vue?vue&type=template&id=2318c34f"
import script from "./PercentageDropdown.js?vue&type=script&lang=js&external"
export * from "./PercentageDropdown.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports